import styled, { createGlobalStyle } from 'styled-components';
import { SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_700, } from '@oneaudi/unified-web-common';
import { GetSafeColorDesignToken } from '../../../../utils/AlphaHelper';
export const ModalHeader = styled.header `
  margin-bottom: ${SYS_SPACE_FIXED_700};
`;
export const DialogStylingOverride = createGlobalStyle `
  & div[id="layer-content"] > div {
  padding-inline: 0px;
  }
`;
export const PriceRow = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const PriceGroupItemsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const PriceRowLabel = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;

  & button {
    height: 20px;
  }
`;
export const PriceRowValue = styled.div `
  white-space: nowrap;
  margin-left: ${SYS_SPACE_FIXED_200};
`;
export const PopoverPriceDisclaimer = styled.div `
  margin-top: ${SYS_SPACE_FIXED_150};
  padding: ${SYS_SPACE_FIXED_200};
  box-shadow: ${GetSafeColorDesignToken('shadow-l1')};
`;
export const PriceGroupStyles = styled.div `
  margin-bottom: ${SYS_SPACE_FIXED_200};
  padding-bottom: ${SYS_SPACE_FIXED_200};
  border-bottom: ${({ isLastItem, isSecondLastItem }) => isLastItem
    ? 'none'
    : isSecondLastItem
        ? `2px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}`
        : `1px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}`};
`;
